if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      connectedCallback() {
        // Ensure children are parsed before querying
        setTimeout(() => {
          this.form = this.querySelector('form');
          if (this.variantIdInput) {
            this.variantIdInput.disabled = false;
          }
          
          if (this.form) {
            this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
          } else {
            console.error('product-form: no form found');
          }
          
          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          this.submitButton = this.querySelector('[type="submit"]');
          
          if (this.submitButton) {
            this.submitButtonText = this.submitButton.querySelector('span');
          }
          
          if (document.querySelector('cart-drawer') && this.submitButton) {
            this.submitButton.setAttribute('aria-haspopup', 'dialog');
          }
        }, 0);
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const formData = new FormData(this.form);
        
        fetch(window.routes.cart_add_url, {
          method: 'POST',
          body: formData,
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(response => response.json())
        .then(response => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
          
          if (this.submitButtonText) {
            const originalText = this.submitButtonText.innerText;
            this.submitButtonText.innerText = 'Added to Cart!';
            setTimeout(() => {
              this.submitButtonText.innerText = originalText;
            }, 2500);
          }
          
          fetch(window.routes.cart_url + '.js')
            .then(res => res.json())
            .then(cart => {
              const countBubble = document.querySelector('.cart-count-bubble');
              if (countBubble) {
                const span = countBubble.querySelector('span[aria-hidden="true"]');
                if (span) span.innerText = cart.item_count;
              }
            });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
        });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form ? this.form.querySelector('[name=id]') : null;
      }
    }
  );
}
